
<template>
    <div>
        <!-- ------------ -->
        <!-- DOUBLE POPUP -->
        <!-- ------------ -->
        <!-- al renderitzar els productes finals, els preus a mostrar, cantitats i nom es el dels kits pares -->
        <!-- ------------ -->
        <div v-if="isDoublePopup" style="margin-bottom: 20px">
            <!-- -------------------- -->
            <!-- BRAND DROPDOWN MOBILE-->
            <!-- -------------------- -->
            <div
                class="d-flex flex-wrap mb-2"
                :style="'width:96%; margin:auto;'"
                v-if="isMobile"
            >
                <span class="mb-2">
                    <!-- <strong>Selección de marca:</strong> -->
                </span>

                <!-- v-model="selectedBrand" -->
                <select
                    @change="selectBrand($event.target.value)"
                    style="padding-left: 10px; width: 300px; height: 40px"
                >
                    <option
                        value=""
                        class="font-weight-bold"
                        :selected="value == ''"
                        hidden
                    >
                        ...
                    </option>
                    <option
                        v-for="brand in element.childs"
                        :key="brand.product_id"
                        :value="brand.product_id"
                    >
                        <span v-if="productsHaveQuantity(brand.product_id) > 0"
                            >*
                        </span>
                        <span>{{ brand.name }}</span>
                    </option>
                </select>
            </div>

            <!-- -------------------- -->
            <!-- BRAND TABLE DESKTOP  -->
            <!-- -------------------- -->
            <div
                class="d-flex flex-wrap mb-2"
                :style="'width:96%; margin:auto;'"
                v-else
            >
                <div v-for="brand in element.childs" :key="brand.product_id">
                    <div
                        class="
                            pointer
                            d-flex
                            flex-column
                            justify-content-center
                        "
                        @click="selectBrand(brand.product_id)"
                        :class="[
                            selectedBrand.product_id == brand.product_id
                                ? 'brandDivSelected'
                                : 'brandDivNotSelected',
                            isMobile ? 'brandDiv_mobile' : 'brandDiv',
                        ]"
                    >
                        {{ brand.name }}

                        <div v-if="productsHaveQuantity(brand.product_id)">
                            <i style="color: green" class="fas fa-check"></i>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ------------- -->
            <!-- SOCKETS TABLE -->
            <!-- ------------- -->
            <!--
            posa només els elements que son productes, no kits, al sockets modal
            agafant la imatge del producte, i la resta del seu kit pare
            a excepció de si es un cambi de nivell, que en la seva estructura de Kits
            que arriba del backend té altre estructura feta
             -->
            <div
                v-if="this.selectedBrand != null"
                :class="
                    isMobile
                        ? 'height_sockets_table_mobile'
                        : 'height_sockets_table'
                "
                class="mb-2"
                :style="'width:96%; margin:auto;'"
            >
                <div class="d-flex flex-row">
                    <div
                        v-for="(kit, index) in this.selectedBrand.childs"
                        :key="kit.product_id"
                    >
                        <!-- <p>{{ kit.name }}</p> -->

                        <div
                            :class="
                                isMobile
                                    ? 'socket_width_mobile'
                                    : 'socket_width'
                            "
                        >
                            <img
                                class="m-1"
                                :class="
                                    isMobile ? 'img_size_mobile' : 'img_size'
                                "
                                :src="kit.image"
                                alt
                            />
                            <div class="m-1 height_name_socket">
                                <strong>{{ kit.name }}</strong>
                            </div>
                            <div v-show="app.currentConfiguration.priceList.show_prices == 1" class="m-2 lightGrey">
                                {{ kit.price | currency }} /
                                {{ element.unit_type }}
                            </div>
                            <div class="m-1" v-if="kit.isQuantityEditable">
                                <!-- <form @submit.prevent=""> -->
                                <!--
                                        @focus="ifCeroBlank(index2)"
                                        @click.stop
                                        @keyup.enter="closeSocketsModal($event)"
                                        @blur="ifBlankCero()"
                                        :ref="index3 + '_' + kit.product_id + '_' + randomId"
                                        :id="index3 + '_' + kit.product_id + '_' + randomId" -->
                                <input
                                    v-bind:readonly="processing"
                                    :disabled="processing"
                                    type="number"
                                    min="0"
                                    class="pl-2 pr-2"
                                    style="width: 65px; text-align: right"
                                    @focus="onFocus($event)"
                                    @keyup="quantityChanged()"

                                    @keydown="app.p4Helper.onKeyDown(kit,$event)"

                                    v-model="kit.quantity"
                                />
                                {{ " " + kit.unit_type }}
                                <!-- </form> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ------------ -->
        <!-- simple popup -->
        <!-- ------------ -->
        <div
            v-else
            class="scrollAuto d-flex flex-row"
            :class="
                isMobile
                    ? 'height_sockets_table_mobile'
                    : 'height_sockets_table'
            "
        >
            <div v-for="(child, i) in element.childs" :key="i">
                <div :class="isMobile ? 'socket_width_mobile' : 'socket_width'">
                    <img
                        class="m-1"
                        :class="isMobile ? 'img_size_mobile' : 'img_size'"
                        :id="'img_' + randomId + '_1'"
                        :src="child.image"
                        alt
                    />
                    <div class="m-1 height_name_socket">
                        <strong>{{ child.name }}</strong>
                    </div>
                    <div v-show="app.currentConfiguration.priceList.show_prices == 1" class="m-2 lightGrey">
                        {{ child.price | currency }} / {{ child.unit_type }}
                    </div>
                    <div v-if="child.isQuantityEditable" class="m-1">
                        <form @submit.prevent="">
                            <input
                                v-bind:readonly="app.isProcessing"
                                type="number"
                                min="0"
                                class="pl-2 pr-2"
                                style="width: 65px; text-align: right"
                                v-model="child.quantity"
                                @focus="onFocus($event)"
                                @click.stop
                                @keyup.enter="closeSocketsModal($event)"
                                @blur="ifBlankCero()"
                                @keydown="app.p4Helper.onKeyDown(child,$event)"
                                @keyup="
                                    quantityChanged(
                                        $event,
                                        i +
                                            '_' +
                                            child.product_id +
                                            '_' +
                                            randomId
                                    )
                                "
                                :ref="
                                    i + '_' + child.product_id + '_' + randomId
                                "
                                :id="
                                    i + '_' + child.product_id + '_' + randomId
                                "
                            />
                            {{ " " + child.unit_type }}
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { app } from "../../application.js";
import { Fragment } from "vue-fragment";
import JQuery from "jquery";
let $ = JQuery;

export default {

    components: { Fragment },

    data() {
        return {
            app: app,
            randomId: Math.random()
                .toString(36)
                .replace(/[^a-z]+/g, "")
                .substr(2, 10),
            hoveredCol: 100,
            lastchangedInputId: "",
            window: { width: 0, height: 0 },
            key_spinner: "",
            selectedBrand: "{id:''}",
            selectedBrandId: null,
            element: new Object(),
            elementIndex: 0,
            processing: false,

        };
    },
    props: {
        isDoublePopup: false,
        product_id: null,
        element_id: null
        // element: new Object()
    },
    methods: {
        filteredBrandsByAvailableSockets: function () {
            //donem un array format nomes amb els products_id de tots els sockets
            let receivedSocketsIds =
                Object.values(this.element.childs.map(socket => socket.product_id && socket.product_id.toLowerCase()));

            //----------------------------
            //comproba que totes les marques que es deixen escollir tenen elements per seleccionar en els childs rebuts del servidor
            //comproba que totes les marques a mostrar estan dins de la concatenacio de tots els receivedSocketsIds
            //si el nom del socket conte el identificador de marca dins posa la marca
            //----------------------------
            return this.element.childs; //.map(socket => socket.product_id && socket.product_id.toLowerCase())
            return this.allBrands.filter(brand => receivedSocketsIds.reduce((a, b) => a + b)); //.includes(brand.id.toLowerCase()));
            //----------------------------
        },
        selectBrand(brandId) {
            var self = this;
            // console.warn("Searching brand: " + brandId)
            this.element.childs.forEach(function (child) {
                if (child.product_id && child.product_id == brandId) {
                    self.selectedBrand = child;
                    // console.warn("Brand changed")
                }
            })
            this.selectedBrandId = brandId;
        },
        productsHaveQuantity: function (productId, element = null, level = 0) {
            // return 0;
            var self = this;
            var productQuantity = 0;
            // var element = null;
            // console.warn("ppp")
            if (!element) {
                // Només del child que es correspon al que estem ensenyant
                // element = this.element;
                // TODO: revisar
                this.element.childs.forEach(function (child) {
                    if (child.product_id && child.product_id == productId) {
                        element = child;
                    }
                })
            }

            if (!element) {
                // alert("KAKA");
                return 0;
            }
            // console.warn(element)
            // console.warn(element.childs)
            // console.warn(element.childs.length)
            // return 0;

            if (element.childs && element.childs.length > 0) {
                element.childs.forEach(function (child) {
                    productQuantity += self.productsHaveQuantity(productId, child, level + 1)
                })
            } else {
                productQuantity += element.quantity;
            }

            return productQuantity;


        },
        closeSocketsModal(e) {
            this.$nextTick(async () => {
                this.$parent.closeSocketsModal();
            });
        },
        pricePerUnit(kit) {
            let totalpricePerUnit = 0;

            Object.entries(kit.childs).forEach(function (kitOrArticle) {

                if (kitOrArticle[1].isKit === 0) {
                    totalpricePerUnit += kitOrArticle[1].price * parseFloat(kitOrArticle[1].quantityFormula);

                } else {
                    Object.entries(kitOrArticle[1].childs).forEach(function (kitOrArticle2nNivell) {
                        if (kitOrArticle2nNivell[1].isKit === 0) {
                            totalpricePerUnit += kitOrArticle2nNivell[1].price * parseFloat(kitOrArticle2nNivell[1].quantityFormula);

                        } else {
                            Object.entries(kitOrArticle2nNivell[1].childs).forEach(function (kitOrArticle3rNivell) {
                                if (kitOrArticle3rNivell[1].isKit === 0) {
                                    totalpricePerUnit += kitOrArticle3rNivell[1].price * parseFloat(kitOrArticle3rNivell[1].quantityFormula);
                                }
                            });
                        }
                    });
                }
            });
            return totalpricePerUnit;
        },
        appendSpinnerToTextbox(refTextbox) {

            //create spinner
            var spinner = document.createElement("i");
            spinner.setAttribute("class", "fa fa-spinner fa-spin mr-2");
            spinner.setAttribute("id", refTextbox + "_spinner");

            //prepend spinner to parent of textbox
            document.getElementById(refTextbox).parentNode.prepend(spinner);

        },
        removeSpinnerFromTextbox(refTextbox) {
            if (document.getElementById(refTextbox + "_spinner"))
                document.getElementById(refTextbox + "_spinner").remove();
        },
        processDelay: async function (e, key_remove_loading) {
            var self = this;
            self.timeout = setTimeout(async function () {
                // TODO:
                // refrescar selectedBrand
                console.warn("process async")
                self.processing = true;
                await self.app.asyncProcess(false, false, false, 0);

                // TODO: refrescar current element....
                // TODO: BUG
                self.selectCurrentElement();

                // TODO: quan es simple, no aplica.
                self.selectBrand(self.selectedBrandId)

                self.processing = false;
                // self.removeSpinnerFromTextbox(key_remove_loading);
            }, 600);
        },
        selectCurrentElement(currentElements = null) {
            // var product_id = this.product_id
            var element_id = this.element_id
            var self = this;
            // alert(this.elementIndex);
            // console.warn(Object.entries(app.currentConfiguration.elements)[this.elementIndex][1]);
            // console.warn(app.currentConfiguration.elements[this.elementIndex])
            //             return;
            // console.warn(app.currentConfiguration.elements[this.elementIndex])
            // return;
            if (!currentElements) {
                currentElements = Object.entries(app.currentConfiguration.elements)[this.elementIndex][1].childs;
                // currentElements = app.currentConfiguration.elements[this.elementIndex].childs;
            }

            var elements = []

            if (Array.isArray(currentElements)) {
                elements = currentElements;
                elements.forEach((element) => {
                    if (element.id == element_id) {
                        self.element = element;
                        console.warn("Found!")
                        return false;
                    } else {
                        if (element.childs)
                            self.selectCurrentElement(element.childs)
                    }
                    return true;
                });
            } else {
                elements = Object.entries(currentElements)
                elements.forEach(([key, element]) => {

                    if (element.id == element_id) {
                        console.warn("Found!")
                        self.element = element;
                        return false;
                    } else {
                        if (element.childs)
                            self.selectCurrentElement(element.childs)
                    }
                    return true;
                });
            }



        },
        ifBlankCero: function () {
            if (this.isDoublePopup) {
                if (this.filteredKits[0].name && (
                    this.filteredKits[0].name.toLowerCase().includes('simon 500') ||
                    this.filteredKits[0].name.toLowerCase().includes('simon 27') ||
                    this.filteredKits[0].name.toLowerCase().includes('niessen zenit')
                ) && this.filteredKits[0].quantity === ''
                ) {
                    this.filteredKits[0].quantity = 0;

                } else {
                    this.filteredKits[0].childs.forEach(child => child.quantity === '' ? child.quantity = 0 : child.quantity);
                }

            } else {
                this.element.childs.forEach(child => child.quantity === '' ? child.quantity = 0 : child.quantity);
            }
        },
        ifCeroBlank: function (keyClickedTextbox) {

            if (this.isDoublePopup) {
                if (this.filteredKits[0].name && (
                    this.filteredKits[0].name.toLowerCase().includes('simon 500') ||
                    this.filteredKits[0].name.toLowerCase().includes('simon 27') ||
                    this.filteredKits[0].name.toLowerCase().includes('niessen zenit')
                ) && this.filteredKits[0].quantity === 0
                ) {
                    this.filteredKits[0].quantity = '';

                } else if (this.filteredKits[0].childs[keyClickedTextbox].quantity === 0) {
                    this.filteredKits[0].childs[keyClickedTextbox].quantity = '';
                }
            } else if (this.element.childs[keyClickedTextbox].quantity === 0) {
                this.element.childs[keyClickedTextbox].quantity = '';
            }
        },
        quantityChanged: async function (e, key_remove_loading) {
            clearTimeout(this.timeout);

            var self = this;

            //com a minim el valor ha de ser 0
            self.element.quantity =
                self.element.quantity || 0;
            await self.processDelay();
            return;

        },
        selectElement(selectedChild) {
            this.$emit("variantChanged", selectedChild);
        },
        hoverCol(numCol) {
            this.hoveredCol = numCol;
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        refresh(elementIndex) {
            // alert(elementIndex);
            this.elementIndex = elementIndex;
            this.selectCurrentElement()
            // this.selectBrand(this.selectedBrandId)
        },

        onFocus: async function (e) {

            // TODO: posar a una classe helper
            if (e.srcElement &&
                e.srcElement.nodeName &&
                e.srcElement.nodeName == "INPUT" &&
                e.srcElement.value == 0) {

                // Si el valor és 0, llavors modificar-lo a '' per què l'usuari
                // no hagi d'esborrar el número 0
                let inputBox = e.srcElement;
                inputBox.value = "";
            }
        },
    },
    computed: {
        filteredKits: function () {
            if (!this.selectedBrand) return [];
            return this.selectedBrand.childs;
        },
        isMobile: function () {
            let a = this.window.width < 650;
            return a;
        },
    },
    created() {
        // this.selectCurrentElement()
        // this.selectBrand(this.selectedBrandId)
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
};
</script>

<style scoped lang="scss">
.height_name_socket {
    height: 75px;
    overflow: hidden;
}

.height_sockets_table {
    height: 425px;
    overflow-y: hidden;
}

.height_sockets_table_mobile {
    height: 390px;
}

.socket_width {
    width: 225px;
}
.socket_width_mobile {
    width: 180px;
}

.scrollAuto {
    overflow-x: auto;
}

.brandDiv {
    width: 250px;
    height: 50px;
    padding: 10px;
    border: 1px solid black;
    margin: 4px;
    border-radius: 3px;
}

.brandDiv_mobile {
    padding: 5px;
    border: 1px solid black;
    margin: 3px;
    border-radius: 3px;
}

.pointer {
    cursor: pointer;
}

.brandDivSelected {
    vertical-align: middle;
    background-color: #c7c7c7;
    -webkit-transition: background-color 300ms linear;
    -ms-transition: background-color 300ms linear;
    transition: background-color 300ms linear;
    outline: none;
}

.brandDivNotSelected {
    background-color: white;
    -webkit-transition: background-color 300ms linear;
    -ms-transition: background-color 300ms linear;
    transition: background-color 300ms linear;
}

.noBorder {
    border-style: none !important;
}

.divCenteredInCell {
    margin: auto;
}

.lightGrey {
    background-color: #f4f4f4;
}

.img_size {
    width: 220px;
    height: 220px;
}

.img_size_mobile {
    width: 170px;
    height: 170px;
}
</style>
